import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-corporate',
  templateUrl: './landing-corporate.component.html',
  styleUrls: ['./landing-corporate.component.css']
})

export class LandingCorporateComponent {

  isShw(): boolean {
    return !location.href.includes('/default');
  }

}